



















































































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCollector from "./createcollector.vue";
import EditCollector from "./editcollector.vue";
import CopyCollector from "./collectorcopy.vue";
import ReplaceCollector from "./replacecollector.vue";
import CollectorImportData from "./collectorImportdata.vue";
import ReplaceDeviceId from "@/views/basedatas/deviceTenant/replacedeviceId.vue";
import Moment from "moment-timezone";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageCollectorRequest extends PageRequest {
  keyword: string;
  areaId: number;
  CollectorType: number = 0;
  isp: number = 0;
  isEnable: number = 9; //nullable
}

@Component({
  components: {
    CreateCollector,
    EditCollector,
    CopyCollector,
    ReplaceCollector,
    CollectorImportData,
    ReplaceDeviceId,
  },
})
export default class collector extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
  //更换采集器
  async replace() {
    this.replaceModalShow = true;
  }
  //更换平台Id
  async replacedeviceid(deviceId: string) {
    this.deviceId = deviceId;
    this.deviceModalShow = true;
  }
  //filters
  pagerequest: PageCollectorRequest = new PageCollectorRequest();
  creationTime: Date[] = [];
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  modelType: any[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  replaceModalShow: boolean = false;
  importModalShow: boolean = false; //导入数据
  menuId: number = 0;
  choosecolumn: any[] = [];
  splitnum: number = 0.15;
  showcolumn: boolean = false; //显示列选择窗口
  deviceId: string = "";
  deviceModalShow: boolean = false; //更新表计平台Id

  //获取菜单Id
  getmenu() {
    let menulist = JSON.parse(localStorage.getItem("userAuth"));
    let menu = menulist.filter((ele) => {
      return ele.value == "collectors";
    });
    if (menu.length > 0) {
      this.menuId = menu[0].id;
    }
    let se = this.columns.filter((ele) => {
      return ele.sortId == 0 || ele.sortId == 1 || ele.sortId == 28;
    });
    se.forEach((ele) => {
      this.columnlist.push(ele);
    });
  }
  //获取自定义字段
  async getuserfields() {
    let res = await this.$store.dispatch({
      type: "userfield/getuserfield",
      data: { menuId: this.menuId },
    });
    //把列加入右边列表
    this.columns.forEach((ele) => {
      if (ele.sortId != 0 && ele.sortId != 1 && ele.key != "Actions") {
        this.choosecolumn.push({
          fieldName: ele.key,
          isShow: true,
          sortCode: ele.sortId,
          showTag: ele.title,
          menuId: this.menuId,
        });
      }
    });
    //如果设置了自定义列
    if (res.length > 0) {
      let restrue = res.filter((ele) => {
        return ele.isShow == true;
      });
      //this.choosecolumn = res;
      restrue.forEach((ele) => {
        let col = this.columns.filter((colum) => {
          return colum.key == ele.fieldName;
        });
        //加入显示列
        if (col.length > 0) {
          col[0].sortId = ele.sortCode;
          this.columnlist.push(col[0]);
        }
      });
      this.choosecolumn.forEach((ele) => {
        let col = restrue.filter((colum) => {
          return colum.fieldName == ele.fieldName;
        });
        if (col.length > 0) {
          ele.isShow = col[0].isShow;
        } else {
          ele.isShow = false;
        }
      });
    } else {
      this.columnlist = this.columns;
    }
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变显示
  handleChange(event: any, val: any) {
    if (event) {
      //选中显示
      let showcol = this.columns.filter((col) => {
        return col.key === val;
      });
      if (showcol.length > 0) {
        let sh = this.choosecolumn.filter((p) => {
          return p.fieldName == val;
        });
        if (sh.length > 0) {
          showcol[0].sortId = sh[0].sortCode;
        }
        this.columnlist.push(showcol[0]);
      }
    } else {
      //不显示
      this.columnlist = this.columnlist.filter((col) => {
        return col.key !== val;
      });
    }
    //排序
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }

  //改变排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.collector.list;
  }
  get loading() {
    return this.$store.state.collector.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnable = val;
    this.$store.commit("collector/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("collector/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("collector/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("collector/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "collector/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.collector.pageSize;
  }
  get totalCount() {
    return this.$store.state.collector.totalCount;
  }
  get currentPage() {
    return this.$store.state.collector.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center",
      sortId: 1,
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      sortId: 5,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      width: 160,
      sortable: true,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      sortable: true,
      width: 160,
      fixed: "left",
      title: this.L("Device") + this.L("Number"),
      key: "no",
      sortId: 4,
    },
    {
      sortable: true,
      width: 160,
      title: this.L("Logic") + this.L("Address"),
      key: "logicNo",
      sortId: 5,
    },
    {
      title: this.L("Imei"),
      key: "imei",
      width: 160,
      sortId: 6,
    },
    {
      title: this.L("IMSI"),
      key: "imsi",
      width: 160,
      sortId: 7,
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      sortId: 8,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("Platform") + "Id",
      key: "ispDeviceId",
      width: 130,
      sortId: 9,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.ispDeviceId },
            },
            params.row.ispDeviceId
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("ISP"),
      key: "isp",
      width: 130,
      sortId: 10,
      render: (h: any, params: any) => {
        let id = params.row.isp;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].name : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].name : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("Model") + this.L("ModelInfo"),
      key: "modelId",
      width: 130,
      sortId: 11,
      render: (h: any, params: any) => {
        let id = params.row.modelId;
        let list = JSON.parse(JSON.stringify(this.modelType));
        let info = list.filter((p) => {
          return p.value == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].label : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].label : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("DeviceTypeId"),
      key: "deviceTypeId",
      width: 160,
      sortId: 12,
      render: (h: any, params: any) => {
        let id = params.row.deviceTypeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].name : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].name : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: "AppId",
      key: "appId",
      width: 130,
      sortId: 13,
    },
    {
      title: "AppSecret",
      key: "appSecret",
      width: 130,
      sortId: 14,
    },
    {
      title: this.L("Protocol"),
      key: "protocol",
      width: 130,
      sortId: 15,
      render: (h: any, params: any) => {
        let id = params.row.protocol;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].name : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].name : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Tenants") + "Id",
      key: "aepTenantId",
      width: 130,
      sortId: 16,
    },
    {
      title: this.L("Product") + "Id",
      key: "productId",
      width: 130,
      sortId: 17,
    },
    {
      title: this.L("MasterId"),
      key: "masterId",
      width: 130,
      sortId: 18,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.masterId },
            },
            params.row.masterId
          ),
        ]);
      },
    },
    {
      title: this.L("Manufacturer") + "Id",
      key: "manufacturerId",
      width: 130,
      sortId: 19,
    },
    {
      title: this.L("Manufacturer") + this.L("Name"),
      key: "manufacturerName",
      width: 130,
      sortId: 20,
    },
    {
      title: this.L("Device") + this.L("Model"),
      key: "deviceModel",
      width: 130,
      sortId: 21,
    },
    {
      title: this.L("Object") + "Id",
      key: "obj_Id",
      width: 130,
      sortId: 22,
    },
    {
      title: this.L("Inst") + "Id",
      key: "obj_Inst_id",
      width: 130,
      sortId: 23,
    },
    {
      title: this.L("Resource") + "Id",
      key: "res_Id",
      width: 130,
      sortId: 24,
    },
    {
      sortable: true,
      title: this.L("IsActive"),
      key: "isEnable",
      sortId: 25,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("SendPartion"),
      key: "sendPartion",
      width: 130,
      sortId: 300,
    },
    {
      title: this.L("RateNum"),
      key: "rateNum",
      width: 130,
      sortId: 300,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 90,
      sortId: 26,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 27,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 300,
      fixed: "right",
      sortId: 28,
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('collectorsDel');
        let edit = this.checkButtonAuth('collectorsEdit');
        let copy = this.checkButtonAuth('collectorsCopy');
        let replaceCollector = this.checkButtonAuth('collectorsReplace');
        let replaceId = this.checkButtonAuth('collectorIdReplace');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("collector/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("collector/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          replaceCollector ? h(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("collector/edit", params.row);
                  this.replace();
                },
              },
            },
            this.L("Replace")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteCollectorInfo"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "collector/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
          replaceId ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.replacedeviceid(params.row.id);
                },
              },
            },
            this.L("ReplacePlateFormId")
          ) : '',
        ]);
      },
    },
  ];
  async getmodelType() {
    await this.$store
      .dispatch("collectormodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async created() {
    this.getmenu();
    await this.getuserfields();
    this.getAreaTree();
    this.getItemDetail();
    await this.getmodelType();
    this.getpage();
    this.pagerequest.isEnable = 9;
  }
  data() {
    return {
      collectorTypedetail: [],
      ispdetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  //数据字典
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 4;
      });
      info.forEach((ele) => {
        this.$data.collectorTypedetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
      //console.log(info)
      let isp = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      isp.forEach((ele) => {
        this.$data.ispdetail.push({
          label: ele.name,
          value: ele.id,
        });
      });
      //console.log(isp)
    }
  }
  //取消注册
  async cancelregister() {
    let val = (this.$refs.selection as any).getSelection();
    let meterId: any[] = [];
    if (val.length > 0) {
      val.forEach((ele) => {
        meterId.push(ele.id);
      });
    }
    if (meterId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Customer"),
      });
      return;
    }
    let res = await this.$store.dispatch({
      type: "collector/cancelRegisterCollector",
      data: meterId,
    });
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.getpage();
  }
  //注册
  async register() {
    let val = (this.$refs.selection as any).getSelection();
    let meterId: any[] = [];
    if (val.length > 0) {
      val.forEach((ele) => {
        meterId.push(ele.id);
      });
    }
    if (meterId.length == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Customer"),
      });
    }
    let res = await this.$store.dispatch({
      type: "collector/registerCollector",
      data: meterId,
    });
    //console.log(res)
    this.$Modal.info({
      title: this.L("Tips"),
      content: res,
    });
    this.getpage();
  }
  //导入数据
  ImportData() {
    this.importModalShow = true;
  }
  //导出数据
  async exportData(type: any) {
    //console.log(type);
    let fileName = Moment().format("x");
    if (type === 'exportCurrentPage') {//当前页数据
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, columns: this.columnlist });
    } else {
      this.pagerequest.skipCount = 0;
      this.pagerequest.maxResultCount = 10000;
      await this.$store.dispatch({
        type: "meter/getAll",
        data: this.pagerequest,
      });
      (this.$refs.selection as any).exportCsv({ filename: fileName, original: false, data: this.$store.state.meter.list, columns: this.columnlist });
    }
  }
}
